import ghost1 from "../assets/halloween/ghost1.svg";
import ghost2 from "../assets/halloween/ghost2.svg";
import ghost3 from "../assets/halloween/ghost3.svg";
import ghost4 from "../assets/halloween/ghost4.svg";
import ghost5 from "../assets/halloween/ghost5.svg";

export const ghosts =[
    {
        id: 1, src: ghost1, top: "24", left:"58", speed: "1.6s", width:'68px'
    },
    {
        id: 2, src: ghost2, top: "60", left:"68", speed: "2.6s", width:'98px'
    },
    {
        id: 3, src: ghost3, top: "33", left:"23", speed: "3.1s", width:'105px'
    },
    {
        id: 4, src: ghost4, top: "62", left:"33", speed: "1.9s", width:'95px'
    },
    {
        id: 5, src: ghost5, top: "67", left:"81.5", speed: "2.2s", width:'62px'
    }
]